import { Component, EventEmitter, Output, Input, OnInit, OnDestroy } from '@angular/core';

import { CustomerService } from '../../services/customer.service';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { InvoiceService } from '../../services/invoice.service';
import { saveAs } from '@progress/kendo-file-saver';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '../../models/UsersBus.model';
import { AppClaims } from '../../models/AppClaims';
import { GlobalsService } from '../../services/globals.service';
import { InventoryService } from '../../services/inventory.service';

@Component({
    selector: 'custom-downloads',
    templateUrl: './custom-downloads.component.html',
    styleUrls: ['./custom-downloads.component.scss']
})
export class CustomDownloadsComponent implements OnInit, OnDestroy {

    constructor(private svc_cust: CustomerService, private svc_data: InvoiceService, private authService: CmProAuthService, private globals: GlobalsService, private inventoryService: InventoryService) {
    }
    data: any;
    @Input() active: boolean = false;
    @Input() standAlone: boolean = false;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    code: string;
    downloadList: string = '';
    collapseSideBar: boolean = false;
    rights: AppClaims = new AppClaims();
    
    ngOnInit() {
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });

        this.getData();
    }
    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
    }
    popupClass: string = 'custom-dl';
    test() {
        this.getData();
    }

    costco(customerName: string) {
        this.svc_data.getCostcoInvoices(customerName).subscribe(
            {
                next:
                    data => {
                        var file = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' });
                        var fileURL = URL.createObjectURL(file);
                        let fileName: string = "Costco-" + customerName + ".xlsm";
                        saveAs(fileURL, fileName);
                    },
                error: (err) => {
                    this.globals.notifyError(err.message, true);
                }
            });
    }

    corrigo(customerId: any, customerName: string, co: any) {
        let param: string = customerId + ":" + co;
        this.svc_data.getCorrigoInvoices(param).subscribe({
            next: data => {
                var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var fileURL = URL.createObjectURL(file);
                let fileName: string = "Corrigo-" + customerName + ".xlsx";
                saveAs(fileURL, fileName);
            },
            error: (err) => {
                this.globals.notifyError(err.message, true);
            }
        });
    }

    serviceChannel(customerId: any, customerName: string, co: any) {
        let param: string = customerId + ":" + co;
        this.svc_data.getServiceChannelInvoices(param).subscribe({
            next: data => {
                var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var fileURL = URL.createObjectURL(file);
                let fileName: string = "ServiceChannel-" + customerName + ".xlsx";
                saveAs(fileURL, fileName);
            },
            error: (err) => {
                this.globals.notifyError(err.message, true);
            }
        });
    }
    roundys() {
        this.svc_data.getRoundysInvoices().subscribe({
            next: data => {
                var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var fileURL = URL.createObjectURL(file);
                saveAs(fileURL, "Roundys.xlsx");
            },
            error: (err) => {
                this.globals.notifyError(err.message, true);
            }
        });
    }
    gfs() {
        this.svc_data.getGFSInvoices().subscribe({
            next: data => {
                var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var fileURL = URL.createObjectURL(file);
                saveAs(fileURL, "GFS.xlsx");
            },
            error: (err) => {
                this.globals.notifyError(err.message, true);
            }
        });
    }
    getData() {
        this.svc_cust.getCustomDownloadReferenceData().subscribe((info: BaseMessageInfo) => {
            this.data = info.dcValues;
        });
    }
    hide() {
        this.active = false;
    }
    hasDownLoadRights() {
        return this.rights?.ExportCostco
            || this.rights?.ExportCorrigo
            || this.rights?.ExportCostco
            || this.rights?.ExportRoundys
            || this.rights?.ExportCostco;
    }
    close() {
        this.hide();
        this.closed.emit(true);
    }

    public show() {
        this.active = true;
    }
    downloadExport(type: string) {
        var url = "";
        var filename = type;

        switch (type) {
            case 'WarehouseThreshold':
                url = "ThresholdExport/TRUE";
                break;
            case 'BranchThreshold':
                url = "ThresholdBranchExport/TRUE";
                break;
            case 'PartsActive':
                url = "PartsExport/TRUE";
                break;
            case 'PartsInactive':
                url = "PartsExport/FALSE";
                break;
            default:
                url = "ThresholdExport/TRUE";
        }


        this.inventoryService.downloadExcel(url).subscribe(
            {
                next:
                    data => {
                        saveAs(data, filename + ".xlsx");
                    },
                error: err => {
                    console.error(err);
                    this.globals.notifyError("Error downloading document", true);
                }
            });
    }

    showDownloadList(download) {
        switch (download) {
            case (download = 'costco'):
                this.downloadList = 'costco';
                this.collapseSideBar = true;
                break;
            case (download = 'corrigo'):
                this.downloadList = 'corrigo';
                this.collapseSideBar = true;
                break;
            case (download = 'service channel'):
                this.downloadList = 'service channel';
                this.collapseSideBar = true;
                break;
            case (download = 'parts'):
                this.downloadList = 'parts';
                this.collapseSideBar = true;
                break;
        }
    }
}

